import { Badge } from "@/v2-components/ui/badge";
import React, { ComponentProps } from "react";

const ProductTagBadge = ({
  tag,
  size = "sm",
}: {
  tag: string;
  size?: ComponentProps<typeof Badge>["size"];
}) => {
  let variant: ComponentProps<typeof Badge>["variant"] = "referral";

  if (tag === "sale" || tag === "new" || tag === "best") {
    variant = tag;
  }

  return (
    <Badge size={size} variant={variant} className="whitespace-nowrap">
      {tag}
    </Badge>
  );
};

export default ProductTagBadge;
